(() => {
  'use strict';
  // Ephemeral page state only: no cookie/storage/network before consent.
  const completed = new Set();
  const describe = ({query, engine, source='results_page', counts, indexVersion='', action='search'}) => {
    if(!String(query||'').trim() || !Number.isInteger(counts?.total) || counts.total<0) return null;
    const key=JSON.stringify([query,engine,source,action]);
    if(completed.has(key)) return null;
    completed.add(key);
    const detail={query:String(query).trim().slice(0,160),resultCount:counts.total,measurementVersion:2,
      searchId:crypto.randomUUID(),engine,searchSource:source,indexVersion,searchAction:action,
      ...Object.fromEntries(['products','patterns','pages'].filter(k=>Number.isInteger(counts[k])&&counts[k]>=0).map(k=>[k+'Count',counts[k]]))};
    window.KickisSearchMeasurement.last=detail;
    document.dispatchEvent(new CustomEvent('kickis:search:completed',{detail}));
    if(window.Shopify?.theme?.role && window.Shopify.theme.role!=='main') {
      let panel=document.querySelector('[data-search-test-status]');
      if(!panel){panel=document.createElement('p');panel.dataset.searchTestStatus='';panel.className='page-width kickis-search-meta';document.querySelector('main')?.prepend(panel);}
      panel.textContent=`Devtest: ${detail.resultCount} träffar för ”${detail.query}” (${detail.engine}). Inga analysdata skickas till produktion. ${detail.indexVersion?'Testindex: '+detail.indexVersion:''}`;
    }
    return detail;
  };
  window.KickisSearchMeasurement={complete:describe,last:null};
})();
